module.exports = __webpack_public_path__ + "img/legende275.1974005a.jpg";